/**
 * Minimal Accessibility Fixes
 * Only fixes critical accessibility issues without affecting layout
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Fix payment icon IDs to be unique
  function fixPaymentIconIds() {
    const paymentIcons = document.querySelectorAll('svg[aria-labelledby^="pi-"] title[id^="pi-"]');
    const usedIds = new Set();
    
    paymentIcons.forEach((title, index) => {
      const originalId = title.id;
      let newId = originalId;
      
      // Find the context (cart, footer, announcement)
      const svg = title.closest('svg');
      const context = svg.closest('.cart, .new-main-cart') ? 'cart' :
                     svg.closest('.site-footer') ? 'footer' :
                     svg.closest('.announcement-bar') ? 'announcement' :
                     'section';
      
      // Create unique ID
      newId = `pi-${context}-${originalId.replace('pi-', '')}-${index}`;
      
      // Ensure uniqueness
      let counter = 1;
      while (usedIds.has(newId)) {
        newId = `pi-${context}-${originalId.replace('pi-', '')}-${index}-${counter}`;
        counter++;
      }
      
      title.id = newId;
      usedIds.add(newId);
      
      // Update aria-labelledby if it exists
      if (svg && svg.hasAttribute('aria-labelledby')) {
        svg.setAttribute('aria-labelledby', newId);
      }
    });
  }

  // Ensure all images have alt text
  function ensureImageAltText() {
    const images = document.querySelectorAll('img:not([alt])');
    images.forEach(img => {
      // Try to get alt text from various sources
      const title = img.getAttribute('title');
      const figcaption = img.closest('figure')?.querySelector('figcaption')?.textContent;
      
      let altText = title || figcaption || '';
      
      // For product images, try to get product title
      if (!altText && img.closest('.grid-product')) {
        const productTitle = img.closest('.grid-product')?.querySelector('.grid-product__title')?.textContent?.trim();
        if (productTitle) {
          altText = `Produktbild: ${productTitle}`;
        }
      }
      
      // For logo images
      if (!altText && (img.src.includes('logo') || img.closest('.site-header__logo'))) {
        altText = 'Logo';
      }
      
      // Default fallback
      if (!altText) {
        altText = 'Bild';
      }
      
      img.setAttribute('alt', altText);
    });
  }

  // Fix list structures - only remove problematic non-li elements
  function fixListStructures() {
    const lists = document.querySelectorAll('ul.product-categories, ol.product-categories');
    lists.forEach(list => {
      const children = Array.from(list.children);
      children.forEach(child => {
        // Only remove text nodes and non-semantic elements
        if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
          child.remove();
        } else if (child.tagName && !['LI', 'SCRIPT', 'TEMPLATE'].includes(child.tagName)) {
          // Check if it's a meaningful element that should be wrapped
          if (child.textContent.trim()) {
            const li = document.createElement('li');
            li.appendChild(child.cloneNode(true));
            list.replaceChild(li, child);
          } else {
            child.remove();
          }
        }
      });
    });
  }

  // Initialize minimal accessibility improvements
  function initMinimalAccessibility() {
    fixPaymentIconIds();
    ensureImageAltText();
    fixListStructures();
  }

  // Run when DOM is ready
  ready(initMinimalAccessibility);

  // Re-run after a short delay to catch dynamically loaded content
  setTimeout(initMinimalAccessibility, 1000);

})();
